import { systemCode } from ".";

export function showLiveSectionOnly() {
    return systemCode === 'BETMEN';
}
